import { createOptions } from 'options';
import type { BoundState as BoundStateType } from 'modules/campaign/common/types';
import { BlockWidget, BlockWidgetProps } from 'components';
import { UserAvatar } from 'components/UserAvatar';
import { fmtMonth } from 'utilities';
import type { EmbeddedUser } from 'modules/core/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';
import { AvatarGroup } from '@ff-it/ui';

export const boundStateOptions = createOptions(['NONE', 'PARTIAL', 'OVERSPENT']);

export const sumProps = {
  width: 100,
  cellProps: { textAlign: 'end' as const },
};

export type RowType = {
  id: string;
  block: BlockWidgetProps;
  manager: EmbeddedUser;
  planners: EmbeddedUser[];
  month: string;
  invoiced: string;
  amount: string;
  remainder: string;
  state: BoundStateType;
  is_overspent: boolean;
};

export const startColumns: ControlledTableColumns<RowType> = [
  flexColumn({
    key: 'block',
    content: 'Block',
    sortable: true,
    render: ({ block }) => <BlockWidget {...block} link clamp />,
  }),
  {
    key: 'manager',
    content: 'Manager',
    sortable: true,
    width: 100,
    cellProps: { textAlign: 'center' },
    render: ({ manager }) => <UserAvatar user={manager} size="xs" />,
  },
  {
    key: 'planners',
    content: 'Planners',
    width: 100,
    cellProps: { textAlign: 'center' },
    render: ({ planners }) => (
      <AvatarGroup size="xs">
        {planners.map((planner) => (
          <UserAvatar key={planner.id} user={planner} />
        ))}
      </AvatarGroup>
    ),
  },
];

export const endColumns: ControlledTableColumns<RowType> = [
  {
    key: 'month',
    content: 'Month',
    cellProps: {
      className: 'align-middle',
    },
    render: ({ month }) => fmtMonth(month),
    sortable: true,
    width: 90,
  },
  {
    key: 'amount',
    content: 'Amount',
    sortable: true,
    ...sumProps,
  },
  {
    key: 'invoiced',
    content: 'Consumed',
    sortable: true,
    ...sumProps,
  },
  {
    key: 'remainder',
    content: 'Remainder',
    sortable: true,
    ...sumProps,
    cellProps: {
      className: 'text-right align-middle font-weight-bold',
    },
  },
];
